<template>
    <h2 class="mt-[20px] sm:mt-[40px]">Benvenuto <span class="text-[#e96932]">{{ formatString(mainStore.utente?.nome) }}</span> !</h2>
    <div class="flex gap-[10px] sm:gap-[30px] items-center justify-around flex-wrap">
        <div class="button p-[20px]" @click="$router.push('/scelta-veicolo')">Valuta veicolo</div>
        <div v-if="mainStore.abbonato?.adm" class="button p-[20px]" @click="$router.push('/archivio')">Il tuo archivio</div>
    </div>

    <div v-if="mainStore.abbonato?.adm" class="block mt-[20px] sm:mt-[60px]">
        <h2>Crediti:</h2>
        <div class="flex flex-wrap justify-around gap-[30px]">
            <div class="credit">
                <h3>VALUTAZIONI</h3>
                <span class="text-[22px] tracking-[-0.5px]">{{ mainStore.abbonato?.nValutazioni }}</span>
            </div>
            <div class="credit">
                <h3>TARGHE</h3>
                <span class="text-[22px] tracking-[-0.5px]">{{ mainStore.abbonato?.nRicercaTarga }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { mainStore } from '../../store/main';
import formatter from "../formatter";

export default {
    name: 'HomeView',
    components: {  },

    data() {
        return {
            mainStore,
            valutazioni: null,
            targhe: null,
        }
    },

    async created() {
        const loader = this.$loading.show();
        await this.getUser();
        loader.hide();
    },

    methods: {
        formatString(string) {
            if(string) {
                return formatter.firstCharacterCapitalize(string);
            }
            return null;
        },
        async getUser() {
            try {
                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/admonline/utenti/utente`)
                
                this.mainStore.utente = { ...response.data?.utente };
                this.mainStore.abbonato = { ...response.data?.abbonato };
            } catch(error) {
                this.mainStore.utente = { nome: localStorage.getItem("user"), username: localStorage.getItem("user") }
                this.mainStore.abbonato = { adm: false }
                /*this.$notify({
                    title: "Errore",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });*/
                console.log("e", error);
            }
        },
    }
}
</script>

<style scoped>
.credit {
    background-color: #f8f9fa;
    border-bottom: 1px solid #e96932;
    text-align: center;
}
</style>